module.exports = __webpack_public_path__ + "img/八公桥镇-c.468c547d.png";